"use strict";
import { LocalOverrideAdapter } from "@statsig/js-local-overrides";
import { getStatsigClient } from "features/gating/sdk/statsig";
export class LocalOverrideAdapterWrapper extends LocalOverrideAdapter {
  constructor(sdkKey) {
    super(sdkKey);
  }
  refreshStatsig() {
    const statsigClient = getStatsigClient();
    const statsigUser = statsigClient.getContext().user;
    statsigClient.updateUserAsync(statsigUser);
  }
  overrideGate(name, value) {
    super.overrideGate(name, value);
    this.refreshStatsig();
  }
  overrideDynamicConfig(name, value) {
    super.overrideDynamicConfig(name, value);
    this.refreshStatsig();
  }
  removeDynamicConfigOverride(name) {
    super.removeDynamicConfigOverride(name);
    this.refreshStatsig();
  }
  removeAllOverrides() {
    super.removeAllOverrides();
    this.refreshStatsig();
  }
  removeExperimentOverride(name) {
    super.removeExperimentOverride(name);
    this.refreshStatsig();
  }
  overrideExperiment(name, value) {
    super.overrideExperiment(name, value);
    this.refreshStatsig();
  }
  overrideLayer(name, value) {
    super.overrideLayer(name, value);
    this.refreshStatsig();
  }
  removeLayerOverride(name) {
    super.removeLayerOverride(name);
    this.refreshStatsig();
  }
}
